import React from 'react'
import { Field } from 'redux-form'
import { TextField, SelectField } from '../../../utils/custom-components'
import { isRequired, isValidDateOfBirth, normalizeDateOfBirth, GENDER_OPTIONS as genders } from '../../../constants'

const PersonalDetailsForm = () => {
  return (
    <div>
      <Field
        name="status"
        component={SelectField}
        label={'Gender'}
        size={'large'}
        options={genders}
        hintText={'Gender'}
        validate={[isRequired]}
      />
      <Field
        name="fullName"
        component={TextField}
        label={'Full Name'}
        size={'large'}
        type="text"
        validate={[isRequired]}
        tooltipPlacement={'topRight'}
      />
      <Field
        name="dateOfBirth"
        component={TextField}
        label={'Date of Birth'}
        size={'large'}
        type="text"
        hintText={'dd/mm/yyyy'}
        maxLength={10}
        normalize={normalizeDateOfBirth}
        validate={[isRequired, isValidDateOfBirth]}
        tooltipPlacement={'topRight'}
      />
    </div>
  )
}

export default PersonalDetailsForm
